import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CourseState } from '../reducers/course.reducer';
import { COURSE_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<CourseState>(COURSE_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: CourseState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: CourseState) => state.loading);
export const selectSaving = createSelector(selectState, (state: CourseState) => state.saving);
export const selectSaved = createSelector(selectState, (state: CourseState) => state.saved);
export const selectError = createSelector(selectState, (state: CourseState) => state.error);
export const selectCourse = createSelector(selectState, (state: CourseState) => state.course);
